import { iNotification, tNotificationType } from '@/Interfaces/storeNotifications';


export function generateNotification(type: tNotificationType, text: string): iNotification {
    return {
        id: crypto.randomUUID(),
        type: type,
        text: text,
        visible: true,
    };
}
